// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"82cff2ca","787":"c74efbde","958":"372fd959"}[chunkId] + ".chunk.js";
};